import React from 'react';
import * as Styled from './AutoCompleteListItemStyles';
import { AutoCompleteListItemProps } from './AutoCompleteListItemTypes';

function AutoCompleteListItem({
  children,
  leftIcon,
  rightIcon,
  active,
  blockListMode = false,
  subDescription,
  ...props
}: AutoCompleteListItemProps) {
  return (
    <Styled.ListItem
      {...props}
      active={active}
      blockListTemplate={blockListMode}
    >
      {leftIcon && (
        <Styled.LeftIconContainer>{leftIcon}</Styled.LeftIconContainer>
      )}
      <Styled.Description>{children}</Styled.Description>
      {subDescription && (
        <Styled.Description>{subDescription}</Styled.Description>
      )}
      {rightIcon && (
        <Styled.RightIconContainer>{rightIcon}</Styled.RightIconContainer>
      )}
    </Styled.ListItem>
  );
}
export default AutoCompleteListItem;
